import { tableHelper } from "@/helpers/table.helper";
import { getBlankCriteria, getBlankRecord, getBlankSapTestingRecord } from "./helpers";
import { getBlankNextPreviousInfo } from "@/store/helpers";

export const state = getInitialState();

export function getInitialState() {
  return {
    listing: {
      criteria: getBlankCriteria(),
      criteriaInfo: tableHelper.getBlankCriteriaInfo(),
      data: [],
      paging: tableHelper.getDefaultPaging("Name", false),
      loading: false,
      loaded: false
    },
    autocomplete: {
      data: [],
      loading: false
    },
    view: {
      data: getBlankRecord(),
      next: getBlankNextPreviousInfo(),
      previous: getBlankNextPreviousInfo(),
      breadcrumbs: [{ text: "..." }],
      loading: false,
      loaded: false,
      providerId: null
    },
    sapTestReading: {
      data: getBlankSapTestingRecord(),
      loading: false,
      successful: null
    },
    sapTestWriting: {
      data: null,
      saving: false,
      successful: null
    },
    riskProfileHelp: {
      providerId: null,
      loading: false,
      loaded: false,
      data: {}
    },
    riskProfileVsl: {
      providerId: null,
      loading: false,
      loaded: false,
      data: {}
    },
    riskProfileUpfront: {
      providerId: null,
      loading: false,
      loaded: false,
      data: {}
    }
  };
}

export function getUnloadedState() {
  return {
    listing: { loaded: false },
    view: { loaded: false },
    riskProfileHelp: { loaded: false },
    riskProfileVsl: { loaded: false },
    riskProfileUpfront: { loaded: false }
  };
}
